import template from './admin-hotel-panel.html';

AdminHotelPanel.DIRECTIVE_NAME = 'ktAdminHotelPanel';
export default function AdminHotelPanel() {
    return {
        restrict: 'A',
        transclude: true,
        controller: function() {},
        controllerAs: 'adminHotelPanelCtrl',
        template,
        bindToController: true,
        scope: {
             heading: '@ktAdminHotelPanel',
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-hotel-panel/admin-hotel-panel-component.js